export default __webpack_public_path__ + "static/media/InstagramDarkTheme.a655a711.svg";